import { BotType, LanguageNameSpaces, UsageType } from "@shared/types";
import {
  Platform,
  TelegramCouplingType,
} from "@shared/features/settings/types";
import { TranslationKeys } from "@shared/common/i18n/types";

export const USAGE_TYPE_TO_INLINE_OBJECT_NAME: {
  [key in UsageType]?: TranslationKeys<LanguageNameSpaces.COMMON>;
} = {
  [UsageType.ACTIVE_TRADE]: "quota.usage_types_inline.active_signal_trades",
  [UsageType.MANUAL_TRADE]: "quota.usage_types_inline.active_manual_trades",
  [UsageType.CLIENT]: "quota.usage_types_inline.primary_api_slots",
  [UsageType.DCA_BOT]: "quota.usage_types_inline.active_dca_bots",
  [UsageType.GRID_BOT]: "quota.usage_types_inline.active_grid_bots",
  [UsageType.TV_BOT]: "quota.usage_types_inline.active_tradingview_bots",
  [UsageType.SIGNAL_BOT]: "quota.usage_types_inline.active_signals_bots",
  [UsageType.BACKTESTING]: "quota.usage_types_inline.monthly_backtesting_runs",
  [UsageType.HEDGING_BOT]: "quota.usage_types_inline.hedging_bots",
};

export const USAGE_TYPE_TO_TITLE_OBJECT_NAME: {
  [key in UsageType]?: TranslationKeys<LanguageNameSpaces.COMMON>;
} = {
  [UsageType.ACTIVE_TRADE]: "quota.usage_types.active_signal_trades",
  [UsageType.MANUAL_TRADE]: "quota.usage_types.active_manual_trades",
  [UsageType.CLIENT]: "quota.usage_types.primary_api_slots",
  [UsageType.DCA_BOT]: "quota.usage_types.active_dca_bots",
  [UsageType.GRID_BOT]: "quota.usage_types.active_grid_bots",
  [UsageType.TV_BOT]: "quota.usage_types.active_tradingview_bots",
  [UsageType.SIGNAL_BOT]: "quota.usage_types.active_signals_bots",
  [UsageType.BACKTESTING]: "quota.usage_types.monthly_backtesting_runs",
  [UsageType.SECURE_CLIENT_INVITE]: "quota.usage_types.secure_client_invite",
  [UsageType.HEDGING_BOT]: "quota.usage_types.hedging_bots",
};

export const BOT_TYPE_TO_USAGE_TYPE: { [key in BotType]?: UsageType } = {
  [BotType.ASAP]: UsageType.DCA_BOT,
  [BotType.GRID]: UsageType.GRID_BOT,
  [BotType.TRADING_VIEW]: UsageType.TV_BOT,
  [BotType.SIGNAL]: UsageType.SIGNAL_BOT,
  [BotType.HEDGING]: UsageType.HEDGING_BOT,
};

export const USAGE_TYPES = [
  UsageType.MANUAL_TRADE,
  UsageType.ACTIVE_TRADE,
  UsageType.SIGNAL_BOT,
  UsageType.GRID_BOT,
  UsageType.DCA_BOT,
  UsageType.TV_BOT,
  UsageType.BACKTESTING,
  UsageType.CLIENT,
];

export const PLATFORM_TO_DISPLAY_NAME: Record<Platform, string> = {
  [TelegramCouplingType.TELEGRAM_BOT]: "Telegram",
  [TelegramCouplingType.WEB_OR_APP]: "Website & App",
};

export const PLATFORM_TO_KEY: Record<
  Platform,
  "telegram_notifications_active" | "web_notifications_active"
> = {
  [TelegramCouplingType.TELEGRAM_BOT]: "telegram_notifications_active",
  [TelegramCouplingType.WEB_OR_APP]: "web_notifications_active",
};

export const PLATFORM_TO_ACTIVE_KEY: Record<
  Platform,
  "is_web_active" | "is_telegram_active"
> = {
  [TelegramCouplingType.TELEGRAM_BOT]: "is_telegram_active",
  [TelegramCouplingType.WEB_OR_APP]: "is_web_active",
};

export const NOTIFICATIONS_SETTINGS_COLUMN_SPANS = [9, 7, 8];
export const MOBILE_NOTIFICATIONS_SETTINGS_COLUMN_SPANS = [14, 5, 5];

export const TELEGRAM_NOTIFICATIONS_BOT_LINK =
  "https://t.me/cornix_notifications_bot";

export const MAX_REASON_LENGTH = 255;
